import { Component, OnInit } from '@angular/core';

import { TranslationService } from '../../services/translation.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    FormsModule,
    TranslatePipe
],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  currentLanguage: string = 'en';
  supportedLanguages: string[] = [];

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.supportedLanguages = this.translationService.getSupportedLanguages();
    this.currentLanguage = this.translationService.getCurrentLanguage();

    this.translationService.currentLanguage$.subscribe((lang) => {
      this.currentLanguage = lang;
    });
  }

  changeLanguage(language: string): void {
    this.translationService.setLanguage(language);
  }

  getLanguageName(language: string): string {
    switch (language) {
      case 'en':
        return this.translationService.translate('ENGLISH');
      case 'ro':
        return this.translationService.translate('ROMANIAN');
      default:
        return language;
    }
  }
}
